module.exports = __webpack_public_path__ + "img/products-4.5a24dc4.jpg";